import axios from 'axios';

import { BACKEND_URL } from 'config';

import { getByPath } from './getByPath';
import { CustomServerError } from './axiosInstance';

// Set up Base Axios instance
const axiosInstance = axios.create({
  baseURL: BACKEND_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

export const setAuthHeader = (authToken: string) => {
  axiosInstance.defaults.headers.common.Authorization = `Bearer ${authToken}`;
};

export const removeAuthHeader = () => {
  axiosInstance.defaults.headers.common.Authorization = '';
};

export const setObservableUserHeader = (accountBillingCode: string) => {
  axiosInstance.defaults.headers.common['X-AccountBillingCode'] = accountBillingCode;
};

export const removeObservableUserHeader = () => {
  delete axiosInstance.defaults.headers.common['X-AccountBillingCode'];
};

axiosInstance.interceptors.response.use(
  response => response,
  response => {
    const status = getByPath(response, 'response.status', {});
    const responseError = getByPath(response, 'response.data', {});
    const serverValidationError = getByPath(responseError, 'errors', null);
    let validationError;

    const error: CustomServerError<{}> = {
      ...responseError,
      title: responseError.description || responseError.title || 'Something went wrong',
      status
    };

    if (serverValidationError) {
      validationError = Object.keys(serverValidationError).map(item => ({
        [item]: serverValidationError[item][0]
      }));

      error.validationError = validationError;
    }

    return Promise.reject(error);
  }
);

export const baseAxiosInstance = axiosInstance;
